import React, {useRef, useState} from "react";
import __ from "lodash";
import AvatarEditor from "react-avatar-editor";
import { FcAddImage } from "react-icons/fc";
import {makeStyles, withStyles} from "@material-ui/core/styles";
import { Box, Modal, Slider, Button } from "@material-ui/core";

// Local style sheet
const styles = {
  container: {
    // marginTop: "50px",
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
  },
  imgContainer: {
    // marginTop: "30px",
    borderRadius: "50%",
    border: "3px solid black",
  },
  img: {
    display: "block",
    borderRadius: "50%",
  },
  input: {
    display: "none"
  },
  addIcon: {
    width: "50px",
    height: "50px"
  },
}

// Styles
const boxStyle = {
  width: "300px",
  height: "300px",
  display: "flex",
  // flexFlow: "column",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  position: "absolute",
  top: "32%",
  left: "27%",
  // backgroundColor: "white"
};
const modalStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  // backgroundColor: "white"
};

// Styled Slider
const StyledSlider = withStyles({
  root: {
    color: 'primary',
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);


// Modal image cropping component
const CropperModal = ({ src, inputRef, setSrc, modalOpen, setModalOpen, setPreview, onChange }) => {
  const [slideValue, setSlideValue] = useState(10);
  const cropRef = useRef(null);

  //handle save
  const handleSave = async () => {
    if (cropRef) {
      const dataUrl = cropRef.current.getImage().toDataURL();
      const result = await fetch(dataUrl);
      const blob = await result.blob();
      setPreview(URL.createObjectURL(blob));
      if (onChange) {
        let fileName = "";
        const files = inputRef.current.files;
        if (files && __.has(files, "0")) {
          fileName = files[0].name;
        }
        onChange({
          fileName: fileName,
          image: dataUrl
        });
      }
      setModalOpen(false);
    }
  };

  return (
    <Modal sx={modalStyle} open={modalOpen}>
      <Box sx={boxStyle}>
        <AvatarEditor
          ref={cropRef}
          image={src}
          style={{ width: "100%", height: "100%"}}
          border={50}
          borderRadius={150}
          color={[0, 0, 0, 0.72]}
          scale={1}
          scale={slideValue / 10}
          rotate={0}
        />

        {/* MUI Slider */}
        <StyledSlider
          min={10}
          max={50}
          // sx={{
          //   margin: "0 auto",
          //   width: "60%",
          //   color: "red"
          // }}
          size="large"
          valueLabelDisplay="auto"
          defaultValue={slideValue}
          value={slideValue}
          onChange={(e, value) => {
            setSlideValue(value)
          }}
        />
        <Box
          sx={{
            display: "flex",
            padding: "10px",
            // border: "3px solid white",
            // background: "black"
          }}
        >
          <Button
            size="small"
            // sx={{ marginRight: "10px", color: "white", borderColor: "white" }}
            // variant="outlined"
            style={{height:24, marginTop: 4, marginLeft: 5}}
            variant="contained"
            color="primary"
            // disabled={!props.canEdit}
            onClick={(e) => {setSrc(null); setModalOpen(false)}}
          >
            cancel
          </Button>
          <Button
            // sx={{ background: "#5596e6" }}
            // size="small"
            // variant="contained"
            style={{height:24, marginTop: 4, marginLeft: 5}}
            variant="contained"
            color="primary"
            // disabled={!props.canEdit}
            onClick={handleSave}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

// Container
const Cropper = (props) => {
  const classes = makeStyles(styles)();

  // image src
  const [src, setSrc] = useState(null);

  // preview
  const [preview, setPreview] = useState(props.newUser ? "images/DefaultAvatar.png" : props.src ?? "images/DefaultAvatar.png");

  // modal state
  const [modalOpen, setModalOpen] = useState(false);

  // ref to control input element
  const inputRef = useRef(null);

  // handle Click
  const handleInputClick = (e) => {
    e.preventDefault();
    inputRef.current.click();
  };
  // handle Change
  const handleImgChange = (e) => {
    setSrc(URL.createObjectURL(e.target.files[0]));
    setModalOpen(true);
  };

  return (
    <>
      <div className={classes.container}>
        <CropperModal
          modalOpen={modalOpen}
          src={src}
          inputRef={inputRef}
          setSrc={setSrc}
          setPreview={setPreview}
          setModalOpen={setModalOpen}
          onChange={props.onChange}
        />
        <small>Click to select image</small>
        <a href="/" onClick={handleInputClick}>
          <FcAddImage className={classes.addIcon}/>
        </a>
        <input
          type="file"
          accept="image/*"
          ref={inputRef}
          className={classes.input}
          onChange={handleImgChange}
        />
        <div className={classes.imgContainer}>
          <img
            className={classes.img}
            src={preview || "images/DefaultAvatar.png"}
            alt=""
            width="200"
            height="200"
          />
        </div>
      </div>
    </>
  );
};

export default Cropper;
